<template>
    <div :class="['input-wrapper', 'form-input-checkbox', { 'input-wrapper-mb-2x': marginBottomDouble, 'has-error': hasError, 'is-required': required }]">
        <input :id="name" type="checkbox" :name="name" v-model="inputValue" />
        <label :for="name" v-html="label"></label>

        <form-input-error v-if="hasError" :error="errors[0]"></form-input-error>
        <form-input-note v-else-if="note" :text="note"></form-input-note>
    </div>
</template>

<script>
    export default {
        props: {
            errors: {
                type: Array,
                required: false,
                default: null
            },

            name: {
                type: String,
                required: true
            },

            label: {
                type: String,
                required: false,
                default: null
            },

            required: {
                type: Boolean,
                required: false,
                default: false
            },

            note: {
                type: String,
                required: false,
                default: null
            },

            marginBottomDouble: {
                type: Boolean,
                required: false,
                default: false
            },

            value: {
                type: Boolean,
                required: false,
                default: null
            }
        },
        
        data() {
            return {
                inputValue: this.value,
                hasError: false
            }
        },

        watch: {
            inputValue(value) {
                if (value === true) {
                    this.hasError = false
                }
            },

            errors: {
                immediate: true,
                handler(errors) {
                    if (errors === null || errors === undefined || errors.length === 0) {
                        this.hasError = false
                    } else {
                        this.hasError = true
                    } 
                }
            }
        }
    }
</script>
